export default {
  share: {
    planCard: {
      viewPriceTable: '料金表を見る',
      facilityDetails: '施設詳細',
      soldOut: '売り切れ',
      planAutoSwitchNotice:
        '{{date}}は「{{soldOutPlan}}」が売り切れです。ご購入可能な「{{selectedPlan}}」を選択しています。'
    },
    activityCategory: {
      RAILWAY_TICKET: '鉄道乗車券',
      AIRPORT_TRANSPORTATION: '空港アクセス',
      SHINKANSEN: '新幹線',
      EXPRESS_BUS: '高速バス',
      BUS_TOUR: 'バスツアー',
      CRUISES: 'フェリー・クルーズ',
      RENTAL_CAR: 'レンタカー',
      CHARTER: 'チャーター',
      ATTRACTION: '施設（入場券）',
      THEME_PARK: 'テーマパーク',
      MUSEUM_GALLERY: 'ミュージアム・ギャラリー',
      AQUARIUM_ZOO: '水族館・動物園',
      TEMPLES_SHINES: '寺社仏閣',
      TOWER_BUILDING: 'タワー・展望台',
      JAPANESE_RESTAURANT: '和食レストラン',
      WESTERN_RESTAURANT: '洋食レストラン',
      CHINESE_RESTAURANT: '中華レストラン',
      OTHER_RESTAURANT: 'レストラン（その他）',
      DESSERT_BEVERAGE: 'デザート・ドリンク',
      SIGHTSEEING_TOUR: '観光ツアー',
      MARINE_SPORTS: 'マリンスポーツ',
      OUTDOOR_ACTIVITIES: 'アウトドアアクティビティ',
      ONSEN: '温泉',
      SPA_MASSAGE: 'スパ・マッサージ',
      JAPANESE_CULTURAL_EXPERIENCE: '日本文化体験',
      JAPANESE_CRAFT_EXPERIENCE: '日本工芸体験',
      JAPANESE_COOKING_EXPERIENCE: '和食作り体験',
      OTHER_EXPERIENCE: 'その他の体験',
      HOTEL: 'ホテル',
      RYOKAN: '旅館',
      VACATION_RENTAL: '民泊',
      BUNDLE: 'セット',
      PASS: 'パス',
      OTHERS: 'その他'
    },
    product: {
      planDateFallbackNotice:
        'ご選択いただいた{{selectedDate}}は完売しております。購入可能な直近の日付（{{displayDate}}）へ切り替わりました。日付をご確認のうえ、ご購入ください。',
      planAutoSwitchConfirmPlan: '選択したプラン：「{{planTitle}}」',
      planAutoSwitchConfirmQuestion: 'よろしいですか？',
      switchLanguageTitle: '言語を変更'
    },
    priceTableDialog: {
      title: '料金表',
      dateFormat: '{{month}}月{{day}}日 ({{weekday}})',
      weekdays: {
        0: '日',
        1: '月',
        2: '火',
        3: '水',
        4: '木',
        5: '金',
        6: '土'
      }
    },
    common: {
      account: 'アカウント',
      myPage: 'マイページ',
      booking: '注文履歴',
      logout: 'ログアウト',
      save: '保存',
      colon: '：',
      multiply: '×',
      next: '次へ',
      return: '戻る',
      toPay: '支払いへ',
      update: '更新',
      search: '検索',
      delete: '削除',
      space: ' ',
      comma: '、',
      titleSeparator: ' ・ ',
      add: '追加購入',
      change: '変更',
      confirm: '確認',
      cancel: 'キャンセル',
      searchPlaceholder: '検索...',
      tilde: '~',
      showMore: 'さらに表示',
      notification: '通知',
      withParentheses: '{{value1}}（{{value2}}）',
      withDashSeparated: '{{val1}} - {{val2}}',
      selectTime: '時間を選択してください'
    },
    price: {
      primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
      prefix: '<currency>{{currency}}</currency><amount>{{amount}}</amount>',
      suffix: '<amount>{{amount}}</amount><currency>{{currency}}</currency>',
      jpyWord: '円',
      cnyWord: '元',
      jpySymbol: '¥'
    },
    footer: {
      terms: '利用規約',
      cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
      copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.',
      recaptchaNotice:
        'このサイトはreCAPTCHAによって保護されており、Googleの<PrivacyLink>プライバシーポリシー</PrivacyLink>と<TermsLink>利用規約</TermsLink>が適用されます。'
    },
    validation: {
      required: '{{field}}は必須です',
      invalid: '有効な{{field}}を入力してください',
      password:
        '大文字、小文字、記号、数字を組み合わせた8文字以上で作成ください',
      imageType: '画像ファイルを選択してください',
      fileSize: '{{size}}MB以下のファイルを選択してください',
      range: '{{field}}は{{min}}から{{max}}の範囲で入力してください',
      requiredSelect: '{{field}}を選択してください',
      nameInvalid: '{{field}}に使用できない文字が含まれています',
      romajiOnly: '{{field}}はローマ字で入力してください',
      emailNotMatch: 'メールアドレスが一致しません',
      emailAlreadyRegistered:
        'このメールアドレスは既に登録されています。ログインボタンからログインしてください。',
      ticketExpired:
        '購入時間はご参加時間よりも後の時間にすることはできません。'
    },
    firebase: {
      'auth/wrong-password': 'ログイン名またはパスワードが間違っています。',
      'auth/user-not-found': 'ログイン名またはパスワードが間違っています。',
      'auth/email-already-in-use': 'メールアドレスは既に登録されています。',
      'auth/too-many-requests':
        'ログイン試行の回数が上限を超えました。しばらくしてからもう一度お試しいただくか、パスワードをリセットしてください。'
    },
    apiErrors: {
      baseError: 'エラーが発生しました。',
      clientError: 'クライアントからのリクエストに誤りがありました。',
      serverError: 'サーバがリクエストの処理に失敗しました。',
      connectionError:
        '接続エラーが発生しました。通信環境をご確認して、再度お試しください。',
      requestError: 'リクエストの作成に誤りがありました。',
      ARSError: {
        AFFILIATE_ID_REQUIRED:
          'リクエスト失敗。会員限定ページのはじめからもう一度お試しください。',
        BOOKING_NOT_ENOUGH_ALLOTMENT:
          '選択された数量に対し在庫が不足しております。別の日時で再度お試しください。',
        BOOKING_NO_AVAILABILITY:
          '選択された数量に対し在庫が不足しております。別の日時で再度お試しください。',
        PERMISSION_DENIED: 'このリソースにアクセスする権限がありません。',
        NOT_FOUND: 'リソースが見つかりません。',
        BOOKING_ALREADY_ISSUED:
          '引換済・使用済のため、キャンセルはお受けできません。',
        BOOKING_RESERVATION_OVERLIMIT: '予約可能数を超えています。',
        BOOKING_RATE_LIMITED:
          'ただいまアクセスが集中しております。\nご不便をおかけし申し訳ございません。\n恐れ入りますが、お時間をおいてから再度下記＜支払いへ＞ボタンから\nお進みいただきますようお願いいたします。'
      },
      lottery: {
        LOTTERY_ALREADY_APPLIED:
          'このチケットはお一人様1回限りのご購入となります。すでにお申し込みいただいております。'
      }
    },
    header: {
      openMenu: 'メニューを開く',
      closeMenu: 'メニューを閉じる'
    },
    login: {
      title: 'ログイン／新規登録',
      caption: 'ログイン、新規登録方法をお選びください。',
      appleLogin: 'Apple',
      googleLogin: 'Google',
      email: 'メールアドレス',
      emailConfirm: 'メールアドレス（確認）',
      password: 'パスワード',
      button: 'ログイン',
      forgotPassword: 'パスワードをお忘れの場合',
      newAccount: '新規登録',
      signInAgree: `※サードパーティアカウントをお持ちの方は簡単にログイン、会員登録できます。\n ※メールアドレスやサードパーティアカウントを使用して会員登録することにより <TermsLink>{{terms}}</TermsLink> および <PrivacyLink>{{privacy}}</PrivacyLink> に同意したものとみなされます。`,
      otpErrorMsg: '確認コードが正しくありません。もう一度お試しください。'
    },
    cart: {
      button: 'カート',
      empty: 'カート内に商品がありません',
      addToCart: 'カートに入れる',
      totalCount: '共 {{count}} 個商品',
      totalAmount: '合計',
      unavailable: '販売不可',
      deleteConfirm: '「{{activityName}}」を削除してもよろしいですか？',
      availabilityConfirmTitle: 'カート内容の確認',
      availabilityConfirmContent:
        'カート内に販売期間終了、または在庫切れの商品が含まれています。これらの商品を削除して、購入手続きを続けてもよろしいですか？',
      availabilityConfirmProceed: '削除して進む',
      availabilityConfirmBack: 'カートに戻る'
    },
    payment: {
      plan: 'プラン',
      dateTime: '日時',
      validityPeriod: '有効期限',
      ticket: 'チケット',
      option: 'オプション',
      discount: '割引',
      total: '合計（税込）',
      details: '詳細',
      submit: '注文へ進む',
      lotterySubmit: '抽選を申し込み',
      lotteryBeforeOpen: '抽選受付前',
      lotteryClosed: '抽選受付が終了しました',
      numberOfPeople: '参加人数',
      totalWithTax: '合計（税込）',
      viewPlan: 'プランを見る',
      warn: '{{unitName}}のみの単独購入はできません',
      optionRequiredTag: '必須',
      optionRequiredTip: 'オプション商品の選択は必須です',
      optionQuantityShortage: 'オプション商品があと{{quantity}}人分必要です',
      optionQuantityPartialShortage:
        '現在の選択数量では、あと{{quantity}}人分が必要です',
      optionQuantityExcess:
        'オプション商品の合計が、プランの数量を{{quantity}}人分超えています',
      planQuantityRequired: 'プランの参加者人数をお選びください'
    },
    password: {
      changePassword: 'パスワード変更',
      resetPassword: 'パスワード再設定',
      sendResetEmail: 'パスワードリセットメールを送信する',
      sendResetEmailSuccess:
        'パスワード再設定用のURLが{{email}}に送信されます、ご確認のうえパスワードをリセットしてください。',
      oldPassword: '以前のパスワード',
      newPassword: '新しいパスワード',
      changePasswordSuccess: 'パスワードを変更しました。'
    },
    emailVerification: {
      title: '確認メールを送信しました',
      description: '{{email}}宛に認証メールを送信しました。',
      instruction: 'メールに記載された確認コードを入力して登録',
      resend: '再発送',
      verify: 'ログイン'
    },
    date: {
      sunday: '日曜日',
      monday: '月曜日',
      tuesday: '火曜日',
      wednesday: '水曜日',
      thursday: '木曜日',
      friday: '金曜日',
      saturday: '土曜日'
    },
    profile: {
      title: 'プロフィール',
      firstName: '名',
      lastName: '姓',
      email: 'メールアドレス',
      confirmEmail: 'メールアドレス（確認）',
      password: 'パスワード',
      gender: '性別',
      birthday: '生年月日',
      birthdayYear: '年',
      birthdayYearPlaceholder: '選択してください',
      birthdayMonth: '月',
      birthdayDay: '日',
      birthdayYearOption: '{{value}}年',
      birthdayMonthOption: '{{value}}月',
      birthdayDayOption: '{{value}}日',
      country: '国、または地域',
      prefecture: '都道府県',
      postCode: '郵便番号',
      postCodePlaceholder: '例：1234567（ハイフンなし7桁）',
      genderOptions: {
        male: '男',
        female: '女',
        other: 'その他'
      },
      updateProfileSuccess: 'プロフィールを更新しました',
      updateProfileFailed:
        'プロフィール更新に失敗しました, しばらくしてからもう一度お試しください',
      creditCardManagement: 'クレジットカード管理',
      creditCardManagementGetErrMsg:
        'クレジットカード情報の取得に失敗しました。'
    },
    weeks: {
      sun: '日',
      mon: '月',
      tue: '火',
      wed: '水',
      thu: '木',
      fri: '金',
      sat: '土'
    },
    empty: {
      message: 'お探しの内容がありません'
    },
    notFound: {
      subtitle: 'このページはご利用いただけません',
      returnHome: 'ホームに戻る'
    },
    notFoundAuth: {
      subtitle: 'このページはご利用いただけません'
    },
    details: {
      title: '詳細を見る'
    },
    orderConfirm: {
      title: 'ご購入前の確認事項（重要）',
      agree: '上記を確認の上、同意する'
    },
    invoice: {
      title: '領収書発行',
      info: '領収書記載情報',
      name: '宛名',
      remarks: '備考欄',
      email: '領収書送付先メールアドレス',
      check:
        '領収書を再発行する場合、2回目以降に発行される領収書には「再発行」と記載されます。\n発行した領収書を印刷し、経費精算等にご利用いただけるかどうかは、お客様ご自身で事前にご確認ください。',
      description: '但し書き',
      cancelFee: 'キャンセル手数料',
      cancelFeeAmount: 'キャンセル料総額',
      content: '領収書内容',
      confirm: '領収書を発行する',
      success: '領収書が正常に発行されました。{{email}}にてご確認ください。',
      price: 'お支払い金額',
      refundAmount: '返金額'
    }
  },
  faq: {
    title: 'よくある質問',
    bookingProcess: {
      title: '予約プロセス',
      q1: '予約できていますか？',
      a1: '予約確定時にご登録のメールアドレスへご案内のメールをお送りしております。予約情報とバウチャーが含まれていますので、ご確認ください。\nメールに「Eチケットを利用」リンクが記載されている場合、タップまたはクリックして直接ご利用ください。\nまた、メール内の「予約詳細」リンクからも予約情報をご確認いただけます。',
      q2: '予約確認メールが届きません。どうしたらいいでしょうか。',
      a2: '「即時予約」の商品は5分以内に予約が確定し、ご登録のメールアドレスにご案内のメールをお送りしております。\n予約確定時間が経過しても予約確定メールが届かない場合は、迷惑メールフォルダをご確認ください。「@linktivity.co.jp」というドメインから送信されます。',
      q3: 'バウチャーの再発行は可能でしょうか。',
      a3: 'はい。アカウントにログインしていただくと、予約情報とバウチャーをご確認いただけます。\n1.アカウントログイン後、画面右上の「マイページ」＞「予約情報」をクリック\n2.該当予約の「詳細を見る」をクリック\n3.バウチャー情報欄からご希望のバウチャーをクリック\n「バウチャーを送信」よりご登録のメールアドレスへ再送信も可能です。'
    },
    payments: {
      title: '支払い',
      q1: '決済の際、ご予約が失敗という表示がされました。どうしたらいいでしょうか。',
      a1: '直ちに新しい予約をせず、まずトップの「予約情報」下の「予約一覧」から予約履歴、または予約メールをご確認ください。予約の情報を確認できない場合、5分ほどを置いてから新しい予約をしてください。',
      q2: '領収書の発行は可能ですか。',
      a2: '領収書発行のシステムはあいにく現在ございませんので、\nご入用の場合は必要事項（対象予約の予約番号、宛名、但し書き、金額）を明記の上、<helpcenter@linktivity.co.jp>宛てにご連絡ください。',
      q3: '支払い方法はどんなものがありますか。',
      a3: 'お支払いにはクレジットカードをご利用いただけます。\n（Alipay、WeChat Payが利用できる商品もございます）\nコンビニ支払い、現金でのお支払いには対応しておりません。',
      q4: '3Dセキュアとは何ですか？',
      a4: '3Dセキュアとは、インターネット上でのクレジットカード決済をより安全に行うための本人認証サービスです。\nクレジットカード情報の盗用による「なりすまし」などの不正使用を未然に防止することができます。\n3Dセキュア登録済のクレジットカードで決済する場合、ご注文時に、ワンタイムパスワードのご入力等でカード会員ご本人の認証を行います。（カード会社により、認証方法は異なります。）',
      q5: '3Dセキュアの登録方法を教えてください。自分のカードが3Dセキュアに対応しているか分かりません。',
      a5: '3Dセキュアは、ご利用のクレジットカード会社へ事前に登録することでご利用いただけます。\nご利用のカードが3Dセキュアに対応しているかどうかや、設定方法につきましては、カード裏面に表示されているカード発行会社の連絡先にお問い合わせください。',
      q6: '3Dセキュアのパスワードが分かりません。3Dセキュアのワンタイムパスワードが届きません。',
      a6: '3Dセキュアの認証画面で必要になるパスワードは、カード会社に事前登録いただいたパスワード、またはワンタイムパスワードです。\nワンタイムパスワードが届かない場合は、迷惑メールフォルダに届いている可能性がございますので、迷惑メールフォルダをご確認ください。\nパスワードがご不明な場合や、ワンタイムパスワードが届かない場合は、カード裏面に表示されているカード発行会社の連絡先にお問い合わせください。',
      q7: '3Dセキュアに登録しているクレジットカードしか使えないでしょうか。',
      a7: '3Dセキュア登録のないカードはご利用いただけません。セキュリティ上、必要となりますので、ご理解ください。 *昨今の不正利用の急増を受け、経済産業省は、2025年3月末を目処に、ECサイトへの本人認証（EMV 3-Dセキュア）の導入を義務化すると発表しました。\nまた2023年3月発行の「クレジットカード・セキュリティガイドライン【4.0版】」には、EC事業者、カード会社（イシュアー・アクワイアラー）および決済代行事業者に向けて、「本人認証導入の義務化およびそれに向けた対応」の旨が追加されました。本予約システムでは、このガイドラインに則り3Dセキュアを必須とした決済システムを導入しております。',
      q8: 'デビットカードも使えますか。',
      a8: 'ご利用いただけます。',
      q9: '3Dセキュア設定にもカード利用限度額にも問題なく、他のウェブサイトではいつも使えるカードなのにエラーが出て決済できません。',
      a9: 'カードに問題ないのに決済ができない場合、カード会社の決済承認システムが「不正利用の疑い等がある」と判断し、お客様のカードを守るために決済を中止した可能性がございます。\n人間の判断と違い、コンピュータは様々な要素を予測をしてその都度判断を行っているため、その時々で決済不可とする場合があります。\n大変お手数ですが、下記のいずれかをお試しください。\n・違うカードで決済を試す\n・時間をおいて再度決済を試す\n・ご利用のカード会社に一度ご連絡いただき、予約したいチケット名と状況を説明し、エラーが外れるようカード会社側での不正検知・決済承認システムの修正をご相談ください。',
      q10: 'カード会社から利用通知が来たのに、マイページに予約情報がなく、予約確定メールも来ません。',
      a10: '下記のいずれかの状況が考えられます。\n・メールアドレスの入力間違い（スペル間違い）\n・通常使っているメールアドレスとは違うメールアドレスで予約を登録した\n・決済と予約が未完了となっている（カード限度額確保のステップまでは進んだものの、何らかのエラーで決済と予約が未完了となっている）\nもし、心当たりのメールアドレスがありましたら、そちらを使いマイページにログインをお試しください。\nログインできない場合、決済と予約の記録をお調べしますので、下記の情報を記載し、LINKTIVITYカスタマーサポートチーム<helpcenter@linktivity.co.jp>へメールでご連絡ください。\n-予約者氏名（英字）：\n-参加希望日：-決済した日・時間帯(例：3/2 19:00)：\n-決済したカードの下3桁：\n-決済したカードの有効期限：\n-金額：\n-予約に使った可能性のあるメールアドレス：'
    },
    changesAndCancellations: {
      title: '変更とキャンセル',
      q1: '間違って予約してしまいました。どのようにキャンセルできますか？',
      a1: 'キャンセル可能な商品の場合は、アカウントから下記の手順でお手続きが可能です。\n1.アカウントログイン後画面右上の「アカウント」＞「予約情報」をクリック\n2.該当予約の「詳細を見る」をクリック\n3.キャンセル情報欄の「キャンセルを開始」＞「キャンセル」をクリック',
      q2: 'キャンセルしました。返金はいつですか。',
      a2: 'キャンセルお手続き後クレジットカード会社からの返金時期は時差がございますので、明確な時期についてお知りになりたい場合はご利用のクレジットカード会社までお問い合わせください。',
      q3: '予約変更は可能でしょうか。',
      a3: '既存予約をキャンセルし、新規でお申し込みください。キャンセル可否やポリシーは商品によって異なりますので、商品ページ下方の「キャンセルポリシー」欄にてお確かめください。'
    },
    accounts: {
      title: 'アカウント',
      q1: 'アカウント登録の方法を教えてください',
      a1: 'サイト右上の「ログイン」から、もしくは商品の予約遷移で新規登録いただけます。\nEメールアドレスの入力間違いが増えておりますので、よくお確かめください。\nなおEメールアドレスだけでなく、AppleやGoogleなどのサードパーティアカウントもご利用いただけます。',
      q2: 'ログインの方法を教えてください',
      a2: 'ご予約されたサイトの右上にある「ログイン」からログイン可能です。',
      q3: 'パスワードを忘れてしまいました。どうしたらいいでしょうか。',
      a3: 'ログインページの「パスワードをお忘れの場合」をクリックし手順に沿ってパスワードを再設定してください。'
    },
    environment: {
      title: '環境',
      q1: '推奨環境について教えてください。',
      a1: '下記環境を推奨しています。\n\n・Firefox （最新版）\n・Safari （最新版）\n・Google Chrome （最新版）',
      q2: '予約確認メールはどのドメインから送信されますか。',
      a2: '「@linktivity.co.jp」というドメインから送信されます。迷惑メール対策でドメイン指定受信設定をされている場合は、予約前に登録をお願いします。'
    },
    ticket: {
      title: 'Eチケット利用',
      q1: 'ワンタイムパスワード認証とはなんですか？',
      a1: '本予約システムでは、お客様のアクセス環境（端末やブラウザなど）が変更された場合にワンタイムパスワード（一度だけ使えるパスワード）を利用して認証を行い、第三者によるEチケットの不正利用を防止します。\n\nEチケットを利用する際に利用するアクセス環境とは異なるアクセス環境で、利用前にEチケットを開いた場合は、この認証が行われます。\n当日利用する際に慌てないように、当日に利用する端末とブラウザでEチケットを開いて確認しておくことをお勧めします。\n\n例：\n1回目、AさんがスマートフォンでEチケットを開いた：ワンタイムパスワード認証は不要です。\n2回目、Aさんが家族のスマートフォンでEチケットを開いた：1回目と違う端末なので、ワンタイムパスワード認証を求める画面が表示され、認証が必要です。\nこの時に入力したメールアドレスがシステムに登録（固定）されます。3回目に違う端末で開いた場合も、この時に登録されたメールアドレスにワンタイムパスワードが送られます。当日も現地で確認できるメールアドレスにワンタイムパスワードを送ることをお勧めします。',
      q2: '突然「お客様のアクセス環境が変わりました」とメッセージが表示されました。 どうしたらEチケットを表示できますか？',
      a2: 'お客様のアクセス環境が変更された（Eチケットを、一番最初に開いた端末とは違う端末や違うブラウザで開いた）ため、ワンタイムパスワード認証が必要な状態です。 メッセージが表示されたら、まず、ワンタイムパスワードを送信するメールアドレスを入力してください。※当日も現地で確認できるメールアドレスを入力し、ワンタイムパスワードを送ることをお勧めします。 次に、入力したメールアドレスにワンタイムパスワードが届いているか確認してください。\nメールが届いたら、本文に記載のワンタイムパスワードを入力してください。正しく入力できたらワンタイムパスワード認証が完了し、Eチケットを表示できます。',
      q3: 'ワンタイムパスワードのメールが届きません。',
      a3: 'ワンタイムパスワードのメールが届かない場合は、迷惑メールフォルダを確認してください。 また、ドメイン指定している場合は「@linktivity.co.jp」を許可する設定を行ってください。 それでも届かない場合は、メールアドレスが間違っている可能性があります。 正しいメールアドレスを入力するか、別のメールアドレスをお試しください。',
      q4: 'ワンタイムパスワードを送信するメールアドレスを変更できますか？',
      a4: 'ワンタイムパスワードを送信するメールアドレスは変更することはできません。一度ワンタイムパスワード認証が完了すると、それ以降は登録したメールアドレスにワンタイムパスワードが送信されます。 Eチケットを利用する端末（当日に現地に持っていくスマートフォンなど）で確認できるメールアドレスを登録することを推奨します。',
      q5: '自分が操作していない時に何回もワンタイムパスワードのメールが送られてきます。不正でしょうか？',
      a5: '以下の可能性が考えられます。\n・ご同行の方にEチケット（バウチャー）を転送した場合：\nお客様がEチケットを開いてワンタイムパスワード認証した後、ご同行の方がEチケットを開こうとすると、違う端末のためワンタイムパスワードメールが送られます。\nこの時、ワンタイムパスワードの送信先がお客様のメールアドレス（ワンタイムパスワード認証時に登録した）で固定されているため、ご同行の方がEチケットにアクセスしたタイミングで何回もメールが届いている可能性があります。\n・不正利用：もし誰にもチケットを転送などしていない場合は、不正利用の可能性がありますので、ご検討いただき、必要に応じて予約の取り直しをおすすめします。',
      q6: '知らないメールアドレスにワンタイムパスワードのメールが送られてしまいます。',
      a6: '以下の可能性が考えられます。\n・ご同行の方にEチケット（バウチャー）を転送した場合：\nご同行の方がEチケットを開いてワンタイムパスワード認証した後、お客様がEチケットを開こうとすると、違う端末のためワンタイムパスワードメールが送られます。\nこの時、ワンタイムパスワードの送信先がご同行の方のメールアドレス（ワンタイムパスワード認証時に登録した）で固定されているため、そちらのメールアドレスに自動的にパスワードメールが送られるようになっています。まずはご同行の方にご確認いただくことをおすすめします。\n・不正利用：もしご同行の方以外のメールアドレスに転送された場合は、不正利用の可能性がありますので、ご検討いただき、必要に応じて予約の取り直しをおすすめします。'
    }
  },
  privacy: {
    lastUpdated: '最終更新日 2022年03月18日',
    companyName: 'リンクティビティ株式会社',
    title: 'プライバシーポリシー',
    personalInfoProtectionPolicy: '個人情報保護方針',
    personalInfoProtectionDescription:
      '当社は、当社の運営する予約サイトLINKTIVITY等において、お客様から個人情報を取得しております。当社は、お客様が安心かつ便利に予約ができるようにするために、お客様の個人情報を保護することは非常に重要なことであると考えており、以下に記載する事項を遵守して個人情報を取り扱っております',
    customerDataManager: 'お客様の個人データの管理者',
    companyAddress:
      '〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F',
    acquisition: '取得の場面',
    acquisitionDescription:
      '当社は、法令により必要とされる場合にはお客様から同意を得た上で、当社の利用目的の達成に必要最低限の個人情報を取得します。',
    usage: '利用の場面',
    usageDescription:
      '当社は、当社の定める利用目的の達成のためにのみ、お客様から取得した個人情報を利用いたします。',
    storage: '保管・保存の場面',
    storageDescription:
      '当社は、お客様から取得した個人情報が外部に漏洩することのないよう、システムセキュリティに留意して個人情報の保管・保存等を行っています。',
    destruction: '破棄・消去の場面',
    destructionDescription:
      '当社は、利用する必要がなくなった個人データ（個人情報の保護に関する法律に定める個人データを意味します。以下同じです。）は、必要がなくなった時点で、遅滞なく破棄します。',
    customerInquiry: 'お客様からのお問い合わせ等への対応',
    customerInquiryDescription:
      '当社は、お客様からの保有個人データ（個人情報の保護に関する法律に定める保有個人データを意味します。以下同じです。）の利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求及び第三者提供の停止請求に対し、法令に従い対応いたします。',
    safetyMeasures: '安全管理措置等',
    safetyMeasuresDescription:
      '当社は、LINKTIVITYサービスに関係する全てのスタッフが、個人情報の重要性を理解できるよう教育を行うほか、個人情報の安全管理のために必要かつ適切な措置を講じています。',
    tableOfContents: '目次',
    policy1: {
      title: '当社が取得する個人情報と利用目的について',
      description:
        '当社は、以下に掲げる利用目的で、お客様のご住所、ご氏名、生年月日、ご連絡先、メールアドレス又は旅券番号等の個人情報を取得し、利用いたします。また、当社は、お客様の同意なく要配慮個人情報を取得いたしません。なお、お客様の個人情報の取得にあたり、個人情報の利用目的が公表されていない場合には、かかる取得の対象となった個人情報の利用目的を、お客様に通知し、又は公表するものとします。また、当社は、保護者の同意なく13歳以下の児童から個人情報を取得しません。13歳以下の児童の個人情報を提供いただく場合、保護者の同意を取得いただいているものとして取り扱いますが、同意がないことが明らかになった場合には、保護者への連絡その他これに付随する目的以外に当該個人情報を利用しません。',
      serviceUsage: {
        title: 'LINKTIVITYサービス利用（会員登録等）のため',
        description:
          'LINKTIVITYサービス利用のため、お客様の個人情報を当社内部で共有します。',
        legalBasis:
          'お客様の要求するサービスや機能を提供するために必要となります。'
      },
      ticketPurchase: {
        title: 'チケット購入のお申込みのため',
        infoItems:
          '当社は、お客様からの商品提供者からのチケット購入の申込み等に際して、お客様のご氏名や、決済情報、旅券番号のほか、健康状態や病歴等といったお客様の健康状態に関する情報等を取得いたします。',
        purpose:
          '当社は、お客様の商品提供者からのチケット購入資格の確認やチケットの代金等の決済のためにお客様の個人情報を取得し、利用いたします。また、かかる目的のために、商品提供者、交通機関、代金決済事業者等（海外の事業者等を含みます。）へお客様の個人情報を提供いたします。',
        legalBasis:
          'お客様の要求するサービスや機能を提供するために必要となります。'
      },
      newsletter: {
        title:
          'ニュースレター（メールマガジン等）の送付等、お客様へのご案内の送付のため',
        legalBasis: 'お客様からの同意に基づき収集します。'
      },
      advertising: {
        title: 'ソーシャルメディアや広告配信プラットフォームを通じた広告のため',
        legalBasis: 'お客様からの同意に基づき収集します。'
      },
      survey: {
        title: 'アンケートへのご記入のお願いのため',
        legalBasis:
          '当社の予約サイト、商品やサービス等の改善のためお客様の同意に基づき収集します。'
      },
      analysis: {
        title: 'お客様情報の解析及び管理のため',
        legalBasis:
          '当社の予約サイト、商品やサービス等の改善することにより、お客様の正当な利益を追求・保護するために必要となります。'
      },
      fraudDetection: {
        title: 'クレジットカード等の不正利用の検知のため',
        legalBasis:
          'お客様のクレジットカードの安全性を確保し、お客様の正当な利益を追求するために必要となります。'
      }
    },
    policy2: {
      title: '個人データの第三者提供について',
      description:
        '当社は、以下のいずれかの場合を除き、お客様から取得した個人データを第三者に提供いたしません。',
      case1:
        'お客様から第三者（商品提供者、海外の旅行業者、ソーシャルメディア事業者、広告配信サービス会社等の事業者を含みます。）への個人データの提供について、本プライバシーポリシーに同意いただく方法その他の方法により、事前にご同意をいただいた場合',
      case2:
        '上記の利用目的の達成に必要な範囲内において個人データの取扱を外部委託した場合',
      case3: '法令に基づき提供を求められた場合',
      case4:
        '人の生命、身体又は財産の保護のために必要な場合であって、お客様の同意を得ることが困難である場合',
      case5:
        '公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、お客様の同意を得ることが困難である場合',
      case6:
        '国又は地方公共団体などが法令に定める事務を実施する上で、協力する必要がある場合であって、お客様の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合'
    },

    policy3: {
      title: '個人データの取扱の委託について',
      description:
        '当社は、前項に基づき当社の利用目的の達成に必要な範囲内で第三者にお客様の個人データの取扱いを委託する場合、委託先に対して必要かつ適切な監督を行います。また、委託先が再委託を行う場合には、当社は、委託先が再委託先に対して、必要かつ適切な監督を行っているか否かを直接又は間接に監督いたします。再委託先が再々委託する場合についても同様とします。'
    },
    policy4: {
      title: 'Cookie情報等の取得について',
      cookie: {
        title: 'クッキー（Cookie）',
        description1:
          'クッキーとは、お客様（ユーザー）についての情報を含む、ユーザーのハードドライブに蓄えられるデータのひとつです。当社では、クッキーを、個人を特定する情報として利用することはありません。また、セッションクッキーですので、一旦ユーザーがそのブラウザを閉じますと、クッキーは保存されません。クッキーは、お客様へのサービス向上、当社サイトのカスタマイズ・広告の効果の測定等の目的で利用します。',
        description2:
          'また、当社は、統計処理データとしてクッキーを分析することによって、お客様のご興味やご関心の高い事項を探知し、それらを活用しているほか、不正アクセス防止のためにも利用しております。',
        description3:
          'クッキーは、お客様のご希望に応じて無効化することができますが、それにより、お客様はLINKTIVITYでのご予約ができなくなります。'
      },
      logFile: {
        title: 'ログ・ファイル',
        description1:
          '当社では、特定の情報を自動的に収集してログ・ファイルに保存しています。この特定の情報には、IP（インターネットプロトコル）アドレス、ブラウザの種類、ISP（インターネットサービスプロバイダ）、参照/終了ページ、オペレーティングシステム、日付/タイムスタンプが含まれます。当社は、これらの情報を、不正アクセスを監視する目的で利用しております。また、当社は、お客様の傾向分析や、サイト管理、サイトにおけるお客様の動向追跡を行っています。',
        description2:
          'ただし、当社は、これらの情報を、特定の個人を識別できないようにして利用しており、取得した情報を上記以外の目的で利用することはありません。'
      },
      webBeacon: {
        title: 'ウェブビーコンについて',
        description:
          '当社では、ウェブビーコンを、アクセス解析及びアフィリエイトプログラムのために利用しています。当社は、ウェブビーコンについて、上記以外の目的での利用や、特定の個人を識別するための利用はしておりません。'
      },
      statisticalAnalysis: {
        title: '統計的分析について',
        description1:
          '当社では、どのサイトやサービスの人気が高いかを確認するために、第三者アクセス解析ツールを利用し、LINKTIVITYサイト内でお客様がアクセスしたページや、ページの履歴を記録しています。',
        description2:
          '当社は、これらのデータを、特定の分野にご興味を示されたお客様に対して、LINKTIVITY内で、その興味に合わせたコンテンツや広告を提供するために使用しています。',
        description3:
          'また、個人を特定しない統計情報を収集することもあります。さらに、第三者アクセス解析ツール上にて当社が収集したクッキー情報と他社が収集したクッキー情報を双方で閲覧可能にすることもあります。'
      }
    },
    policy5: {
      title: '匿名加工情報の取扱いついて',
      creation: {
        title: '匿名加工情報の作成',
        description1:
          '当社は、匿名加工情報を作成する場合には、以下の対応を行います。匿名加工情報とは、法令の定めによる措置を講じて特定の個人を識別することができないように個人情報を加工して得られる個人に関する情報であって、当該個人情報を復元することができないようにしたものをいいます。',
        description2:
          '①法令で定める基準に従い、適正に加工すること ②法令で定める基準に従い、削除した情報や加工の方法に関する情報の漏えいを防止するために安全管理措置を講じること③作成した匿名加工情報に含まれる情報の項目を公表すること④作成に用いられた個人情報に係る本人を識別するための行為をしないこと'
      },
      provision: {
        title: '匿名加工情報の提供',
        description:
          '匿名加工情報を第三者に提供する場合には、提供しようとする匿名加工情報に含まれる個人に関する情報の項目と提供の方法を公表するとともに、提供先となる第三者に対して、提供する情報が匿名加工情報であることを明示します。'
      },
      disclosure: {
        title: '匿名加工情報に関する公表',
        creationSubtitle: '匿名加工情報の作成について',
        creationDescription:
          '当社が保有する以下のお客様の個人情報について、当社は、特定の個人を識別すること及び個人情報を復元することができないよう適切な措置を講じたうえで匿名加工情報として継続的に作成いたします。',
        itemsTitle: '匿名加工情報に含まれる個人に関する情報の項目',
        itemsDescription:
          'プラットフォームサービスの提供に関して取得した情報購入日、参加日、バウチャーの言語、販売金額のレンジ、参加人数、予約の状態（予約確定かキャンセル等）、サプライヤーの所在地域及び県情報、旅行会社の所在国',
        thirdPartyTitle: '匿名加工情報の第三者提供について',
        thirdPartyDescription:
          '当社が作成または保有する匿名加工情報について、当該情報が匿名加工情報であることを明示したうえで、継続的に第三者に提供いたします。',
        provisionMethod:
          'パスワードにより保護された電子ファイルを電子的な通信手段（電子メール、サーバーにアップロード、API連携等）、またはDVD等の物理媒体により送付'
      }
    },
    policy6: {
      title: '個人データの安全管理措置について',
      description1:
        '個人データの漏えい、盗用、悪用、不正アクセス、改ざん及び破壊等を防ぐために、組織的、技術的、物理的な安全管理措置を講じています。当社が個人データを保存するサーバーへのアクセスは、ID／PWを有する特定の従業員のみに制限されており、中でも一部の個人データの管理については、データの管理等に必要最小限の従業員にのみアクセスを付与しています。',
      description2:
        '更にクレジットカード情報を含む個人データについては、複数のデータセンターに分散してセキュアな環境において保管しています。また、当社は、予約取引に関するすべてのページでSecure Sockets Layer（SSL）暗号を使用しています。SSL対応ブラウザの使用により、インターネット上で送信する個人データとクレジットカード情報の機密性を保持することができます。',
      description3:
        'また、お客様の個人データを取り扱う当社の従業員は、端末を離れるときにはパスワードで保護されたスクリーンセーバーを使用しております。',
      description4:
        'さらに､当社は、部署によっては毎月1回、全社的には半年に1回以上の頻度で、個人情報の重要性等に関する教育研修を実施しております。また、教育に関する記録もとっております。'
    },
    policy7: {
      title: 'お客様の個人データの取扱いに関する権利について',
      description:
        '2016年4月27日付のEU一般データ保護規則（GDPR）2016/679に基づき、個人データの処理に関し、お客様は以下の権利があります。',
      right1: 'アクセス権',
      right2: '訂正権',
      right3: '削除権（忘れられる権利）と処理を制限する権利',
      right4: 'データポータビリティー権',
      right5: '異議を述べる権利',
      right6: 'プロファイリングを含む自動処理に基づく決定に服されない権利。'
    },
    policy8: {
      title: '開示・訂正・利用停止等の請求等について',
      description1:
        '当社は、お客様からの保有個人データの利用目的通知の求め、開示請求、訂正・追加・削除請求、利用停止・消去請求又は第三者提供の停止請求（以下、総称して「開示等の請求等」といいます。）に対しては、下記11記載の連絡窓口にて対応いたします。',
      description2:
        'また、当社は、お客様のマイページにおいて、会員情報の変更及び確認並びにメールマガジンの配信停止等のご希望に応じることとしております。'
    },
    policy9: {
      title: '外部へのリンクについて',
      description:
        'LINKTIVITYホームページには、他のサイトへのリンクが含まれています。本プライバシーポリシーは、LINKTIVITYホームページによって収集される情報だけに適用され、その他のウェブサイトのプライバシーポリシーまたはコンテンツについて、当社は責任を負いません。お客様におかれましては、リンク先の各ウェブサイトで、プライバシーポリシーをお読みいただき、お客様の個人情報の取扱いについてご確認いただきますようお願い申し上げます。'
    },
    policy10: {
      title: 'プライバシーポリシーの変更について',
      description:
        '当社は、プライバシーポリシーをLINKTIVITYホームページ上に掲載し、当社がお客様のどのような個人情報をどのような目的で取得し、利用しているか、お客様が常に知ることができる状態にしています。また、プライバシーポリシーの変更についても、LINKTIVITYホームページ上に掲載し、お客様に公表しております。'
    },
    policy11: {
      title: '連絡先について',
      description1:
        '当社のプライバシーポリシーや、当社の個人情報保護への取り組み、お客様の個人情報の取得、利用等に関するご質問又は開示等の請求等については、下記のお問い合わせフォームをご利用ください。担当者より5営業日以内に返答させていただきます。',
      company: 'リンクティビティ株式会社',
      address: '〒100-0011 東京都千代田区内幸町2-1-6 日比谷パークフロント 19F',
      dpoContact: 'データ保護責任者の連絡先 dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '取得する個人情報の項目',
      specificPurpose: '具体的な利用目的',
      legalBasis: '法的根拠：',
      provisionMethod: '提供の方法'
    }
  },
  terms: {
    title: 'LINKTIVITY利用規約',
    lastUpdated: '最終更新日 2020年05月01日',
    intro: {
      company: 'リンクティビティ株式会社（以下、「当社」といいます）は、',
      serviceDesc:
        'のサービスのご利用に関して、以下のとおりLINKTIVITY利用規約（以下、「本規約」といいます）を定めています。',
      agreement:
        'LINKTIVITYをご利用いただいた場合は、本規約に同意したものとみなしますので、LINKTIVITYのサービスをご利用いただきます際には、必ず本規約をお読みください。なお、本規約は、必要に応じ変更することがございますので、ご利用の際には最新の内容をご参照ください。',
      privacyNote: '＊個人情報の取り扱いについては、',
      privacyLinkText: '「個人情報保護方針」',
      privacyNoteSuffix: 'をお読みください。'
    },
    article1: {
      title: '第一条 規約の目的',
      content:
        '本規約は当社が運営する商品・サービス等の場貸し（プラットフォーム）販売サイト「LINKTIVITY」のサービス利用者に適用するものです。本サービスの利用者は、あらかじめ本規約に同意した上で、本サービスを利用するものとします。また、本規約は予告なく変更することがあります。'
    },
    article2: {
      title: '第二条 会員登録',
      items: [
        '「会員」とは、本規約を承認の上、本規約に基づき本サービスの提供を受けるために当社の指定する会員登録手続を完了し、当社が会員として承認した個人とします。ただし、承認後でも、当社が会員として不適当と判断した場合には承認の取り消しを行うことがあります。',
        '会員登録の際の登録情報に関して、いかなる虚偽の申告も認めないものとします。本人、登録情報（氏名、メールアドレス等）、パスワードは、それぞれ一つずつのみ対応するものとし、同一人物による複数の会員としての登録は認めないものとします。',
        '登録情報に変更が生じた場合は、会員は速やかに所定の変更手続きを行うものとします。'
      ]
    },
    article3: {
      title: '第三条 商品提供者が提供する情報',
      content:
        '当社は、LINKTIVITYにおいて、商品提供者が提供する内容、料金、購入可能日時、取消規定（キャンセルポリシー）等購入に必要な情報(以下、「購入関連情報」といいます)、および商品提供者に関する情報を会員に提供しますが、購入関連情報は、商品提供者の責任において提供されるものであり、当社が故意または過失による情報の非伝達のため発生したものを除き、当社は情報の内容については一切責任を負うものではありません。'
    },
    article4: {
      title: '第四条 契約成立',
      content:
        'LINKTIVITYのプラットフォームでは会員が購入する商品、サービス等の提供に関する契約は、会員と商品提供者との間で直接締結されます。LINKTIVITYにおける商品、サービス等の掲載は、商品提供者への申し込みを行うためのものであり、当社はその申し込みを当該商品提供者に代わって自由に承認または却下できます。本利用規約は、会員によるLINKTIVITYサービスの使用を規定するものであり、商品提供者への購入申し込みを行うためにLINKTIVITYを使用する場合も含みます ただし、会員が予約する商品・サービス等の提供は、LINKTIVITYに表示される契約条件、予約手続中に提示される情報、およびプ商品・サービス等の提供に関する法的な契約の締結先である商品提供者が定める契約条件に従うものとします。'
    },
    article5: {
      title: '第五条 代金のお支払',
      content: [
        'LINKTIVITYは商品提供者の代金回収代理業者として、会員のお支払い情報を取得し、支払いを処理します。会員は、商品・サービス等の購入時に当社へクレジットカードまたは当社が提供する決済手段にて代金を支払うものとします。外貨表記ので、当社が日本円でクレジットカード決済額または当社が提供する決済手段の請求金額を決定する場合は、当社が定めるレートにて日本円に換算することとします。',
        '但し、一部については、ページで指定された次のいずれかの方法で支払うものとします。'
      ]
    },
    article6: {
      title: '第六条 商品提供者が提供する商品・サービスの内容・品質',
      content:
        '当社は、商品提供者が提供する商品・サービスの内容・品質については一切責任を負うものではなく、会員と商品提供者との間で生じるトラブル、紛争もしくは苦情、会員が被る損害については、会員が商品提供者との間で解決するものとし、当社はこれらにつき何ら責任を負うものではありません。'
    },
    article7: {
      title: '第七条 利用環境',
      items: [
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の購入に必要な通信機器・ソフトウェア・通信手段等必要なものの全てを用意するものとします。',
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の利用に必要なインターネットに接続可能なスマートフォン・ソフトウェア・通信手段等必要なものの全てを用意するものとします。'
      ]
    },
    article8: {
      title: '第八条 会員の自己都合による購入の取消、取消料',
      items: [
        '会員の自己都合で購入を取消す場合の取消料は、該当商品提供者が定める取消規約（キャンセルポリシー）に則ります。',
        '当社は代金支払時と代金返金時の為替差損益については一切責任を負うものではありません。',
        '購入の取消は、原則、LINKTIVITYのマイページより行うものとします。但し、利用日直前で、商品提供者に直接電話で連絡がとれ、かつ商品提供者が購入の取消を受付けた場合は、後日、マイページよりLINKTIVITYへ、その旨連絡することにより取消手続きは完了するものとします。'
      ]
    },
    article9: {
      title: '第九条 商品提供者による取消、返金',
      content:
        '商品・サービス等の内容変更、中止に伴う会員への告知は商品提供者が行い、当社は商品・サービス等の変更、中止に伴なう責任は一切負いません。ただし、当社は商品提供者の決定・依頼に基づき販売した商品・サービス等の内容の変更や中止による商品・サービス等の払い戻し業務を代行する場合があります。'
    },
    article10: {
      title: '第十条 パスワードの管理',
      items: [
        '会員は、パスワードの管理責任を負うものとします。',
        '会員は、メールアドレス、パスワードを第三者に利用させたり、貸与、譲渡、名義変更、売買、質入等を行うことはできないものとします。',
        '会員のパスワードの管理不十分、使用上の過誤、第三者の使用等による損害の責任は、会員が負うものとし、当社は一切責任を負いません。'
      ]
    },
    article11: {
      title: '第十一条 会員登録情報の取扱い',
      items: [
        '会員登録の際に会員が登録した個人情報（以下、「登録情報」といいます）は、当社の個人情報保護方針に従い、当社が保有、管理するものとします。',
        {
          text: '当社は、登録情報のうち、特定の個人の識別が可能な情報（以下「個人情報」という。）を、第三者に開示しないものとします。ただし、以下の場合を除きます。',
          subItems: [
            '情報開示についてお客様の同意がある場合',
            '個人情報保護のための守秘義務契約を結んだ業務委託先に対しサービスを履行するために必要な個人情報を提供する場合',
            'サービス向上目的で個人情報を集計および分析し、個人を識別または特定できない状態で第三者に開示または提供する場合',
            '裁判所の発する令状その他裁判所の判断に従い開示する場合'
          ],
          note: 'なお、当社が取得した個人情報に関する、利用目的その他取り扱いについての詳細は「個人情報保護方針」をお読みください。'
        }
      ]
    },
    article12: {
      title: '第十二条 会員の禁止事項',
      intro:
        '会員は、LINKTIVITYを利用する際に、以下の行為またはそのおそれのある行為を行ってはならないものとします。',
      items: [
        '本規約に違反する行為',
        '公序良俗または法令に違反する行為',
        '当社、他の会員または第三者の著作権、肖像権、その他知的所有権を侵害する行為',
        '他の会員または第三者を誹謗・中傷する行為',
        '他の会員または第三者に不利益を与える行為',
        '当社の事業あるいは当社の提供するサービスの運営を妨害する行為',
        '営利を目的とする行為',
        '会員として得た権利を、当社の事前の同意を得ることなく第三者に譲渡および貸与する行為',
        'その他、当社が不適当と判断する行為'
      ]
    },
    article13: {
      title: '第十三条 会員発信情報の削除又は修正',
      intro:
        '当社は、会員が送信した情報のうち、以下のいずれかに該当するまたはそのおそれがあるものを、会員の承諾なく、全部または一部を削除し、またはこれに対し当社が必要と判断する修正を行うことができるものとします。',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当すると当社が判断するもの',
        '事実に明らかに反すると当社が判断するもの',
        'その他当社が不適当と判断するもの'
      ]
    },
    article14: {
      title: '第十四条 会員資格の抹消',
      intro:
        '会員が以下の事由のいずれかに該当する場合、当社は会員に事前の通知することなく、また会員に対して何らの責任を負うことなく、会員資格を抹消することができるものとします',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当する行為を行った場合',
        'その他、本規約のいずれかに違反した場合。',
        'その他、会員として不適格と当社が判断した場合'
      ]
    },
    article15: {
      title: '第十五条 サービスの変更・中断・中止',
      items: [
        '当社は、会員に事前に通知することなく、サービス内容を変更、中断または中止する場合があります。',
        '本サービス内容の変更または中断に伴い、会員に不利益または損害が発生した場合であっても、当社はその責任を負わないものとします。',
        '当社は、会員に対して１ヶ月前に通知することにより、サービスの提供を中止することができるものとします。'
      ]
    },
    article16: {
      title: '第十六条 著作権および財産権',
      content:
        'LINKTIVITYに表示されるすべての内容に関する著作権および財産権は、当社および当社にそれらの内容を提供している、商品提供者、提携先、広告主に帰属しています。利用者および会員は、当社、商品提供者、提携先、広告主の事前の文書による承諾を受けた場合を除いて、それらの内容を複製、公開、譲渡、貸与、翻訳、転載、送信、使用許諾、再利用しないことなどに同意するものとします。また、利用者および会員がこれらの行為によって得た利益相当額を当社が請求できる権利を有していることとします。'
    },
    article17: {
      title: '第十七条 免責・責任制限',
      items: [
        '当社は、会員と商品提供者との間で生じた損害、会員が本規約に違反して生じた損害、商品・サービス等のチケットへの引き換えにおいて当社の責に帰さない事由により発生した損害については、一切の責任を負わないものとします。',
        '商品提供者は、当社とは独立した契約主体であり、商品提供者による、いかなる行為、過失、怠慢、代理行為、保証や、商品・サービス等の参加に関連する会員の負傷、死亡、所有物の損傷・遺失テロリズムに帰する損害、その他あらゆる損害等について、当社は一切責任を負うものではありません。',
        '当社は、当社の直接の管理範囲を超えた原因により生じた、商品・サービス等の遅延、キャンセル、重複購入、ストライキに対する責任を負わないものとします。また、政府当局や裁判所令状等による内容変更、キャンセル、遅延、追加費用の発生等についても応じる義務を負いません。',
        '当社は、当社に故意または過失がある場合においても、会員に対し、本サービスの提供に関連して会員に発生した現実かつ直接の通常損害以外の損害を負担しません。'
      ]
    },
    article18: {
      title: '第十八条 本規約の変更',
      content:
        '本規約の内容について、当社は必要に応じ変更できるものとします。本規約を変更した場合は、本画面上の変更をもってその変更が終了したものとし、都度、会員への通知は行わないものとします。'
    },
    article19: {
      title: '第十九条 合意管轄',
      content:
        '本規約に関する一切の紛争については、東京地方裁判所を第一審の専属管轄裁判所とします。'
    },
    article20: {
      title: '第二十条 協議',
      content:
        '本規約に定めのない事項又は本規約に関する疑義が生じた場合には、関係当事者間にて誠意をもって協議し、円満に解決するよう努めるものとします。'
    }
  },
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: 'サービス名',
    companyName: '販売事業者',
    representative: '代表者名',
    address: '所在地',
    contact: 'お問い合わせ先',
    paymentTerms: '代金の支払方法・支払時期',
    deliverySchedule: '商品の引渡時期',
    sellingPrice: '商品等の販売価格',
    shippingFee: '送料',
    additionalFee: '販売価格・送料等以外に必要な料金',
    salesRestrictions: '販売期間・販売数量の制限',
    returnsAndCancellations: '返品・キャンセル',
    otherConditions: 'その他の条件'
  },
  requireForm: {
    lastName: '姓',
    firstName: '名',
    participantInfo: '利用者情報',
    requiredBookingInfo: '必要情報',
    BookingFieldMethod: {
      PER_PARTICIPANT: '参加者ごと',
      PER_BOOKING: '予約ごと'
    },
    bookingFields: {
      participantEmailAddress: '参加者メールアドレス',
      hotelName: '宿泊先名',
      hotelAddress: '宿泊先住所',
      hotelReservationLastName: '宿泊代表者氏名（姓）',
      hotelReservationFirstName: '宿泊代表者氏名（名）',
      hotelReservationName: '宿泊代表者氏名',
      hotelTel: '宿泊先電話番号',
      arrivalDate: '現地到着日',
      arrivalTime: '到着時刻',
      arrivalFlightNumber: 'フライト到着便名',
      departureDate: '出発日',
      departureTime: '出発時刻',
      departureFlightNumber: 'フライト出発便名',
      destinationEmail: '現地連絡先（メールアドレス）',
      destinationTel: '現地連絡先（電話番号）',
      gender: '性別',
      agentChannelRegion: '旅行代理店所在国・地域',
      agentChannelLanguage: '旅行代理店言語',
      participantResidentRegion: '参加者居住国・地域',
      participantLanguage: '参加者言語',
      passengersQuantity: '乗車人数',
      prescriptionMaskQuantityFree: '度付きマスク希望　※無料',
      prescriptionMaskQuantityPaid: '度付きマスク希望　※現地払い',
      preferredStartTime: '希望開始時間',
      preferredPickUpLocation: 'お迎え・乗車場所',
      preferredDropOffLocation: 'お送り・降車場所',
      participantsQuantity: '参加人数',
      luggageQuantity: 'スーツケースの数（合計）',
      childrenWithoutSeatQuantity: '座席を必要としない幼児',
      childSeatQuantityPaid: 'チャイルドシートのご利用 ※現地払い',
      childSeatQuantityFree: 'チャイルドシートのご利用 ※無料',
      guideJa: '日本語ガイド希望',
      driverJa: '日本語ドライバー希望',
      guideEn: '英語ガイド希望',
      driverEn: '英語ドライバー希望',
      guideZh: '中国語ガイド希望',
      driverZh: '中国語ドライバー希望',
      guideKo: '韓国語ガイド希望',
      driverKo: '韓国語ドライバー希望',
      preferredGuideLanguageCode: 'ご希望のガイド言語',
      preferredDriverLanguageCode: 'ご希望のドライバー言語',
      passportNationality: '国籍',
      passportFirstName: '参加者名（パスポート記載のローマ字名）',
      passportLastName: '参加者姓（パスポート記載のローマ字姓）',
      dateOfBirth: '生年月日',
      age: '年齢',
      passportNumber: 'パスポート番号',
      eyesight: '視力',
      weightKg: '体重（kg）',
      heightCm: '身長（cm）',
      shoeSizeCm: '靴のサイズ（cm）',
      weightLbs: '体重（lbs）',
      heightIn: '身長（ft/in）',
      clothesSize: '服のサイズ',
      vegetarianMeals: 'ベジタリアンフード希望',
      divingExperienceTimes: 'ダイビング経験本数',
      rentalEquipmentsFree: '器材レンタル希望　※無料',
      rentalEquipmentsPayLocally: '器材レンタル希望　※現地払い',
      male: '男性',
      female: '女性',
      other: 'その他',
      yes: 'はい',
      no: 'いいえ'
    }
  },
  components: {
    selectOption: {
      title: 'オプション',
      quantity: '数量：{{quantity}}',
      addCart: 'カートに入れる',
      planSelect: 'パッケージを選択してください',
      dateSelect: '日付を選択してください',
      dateLabel: '日付',
      timeSelect: '時間を選択してください',
      quantitySelect: '数量を選択してください',
      quantitySelectLabel: '数量',
      soldOut: '売り切れ',
      total: '合計',
      viewDetail: '詳細を見る',
      unitRatioNotCounted: '※このオプションは合計数にカウントされません',
      unitRatioCounted: '※1つで{{quantity}}人分としてカウントされます'
    },
    planDetailDrawer: {
      title: 'プラン詳細',
      planContent: 'プラン内容',
      meetingPlace: '集合場所',
      cancellationPolicy: 'キャンセルポリシー',
      capacity: '予約可能数',
      maxCapacity: '最大予約可能数',
      minCapacity: '最小予約可能数',
      bookingAcceptance: '予約可能期間',
      bookingDeadline: '予約受付期限',
      voucherExpirationPeriod: 'バウチャーの有効期限',
      inclusion: '含まれるもの',
      participationLocations: '参加場所',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: '場所説明',
        NOTE_OF_LOCATION_AND_DIRECTION: '場所、行き方の補足説明',
        LANDMARKS_TO_MEETING_POINT: '集合場所までのランドマーク',
        PICK_UP_CAR: '迎えに行く車',
        PICK_UP_GUIDE: '迎えに行くガイド',
        ITINERARY: 'スケジュール',
        PARKING: '駐車場について'
      },
      restrictions: '参加制限',
      requirements: '参加前・参加時必要事項',
      attireItems: '参加時必要な服装・持ち物',
      otherInfo: '備考・その他'
    },
    payment: {
      ticket: 'チケット',
      option: 'オプション',
      total: '合計（税込）',
      details: '詳細',
      submit: '注文へ進む'
    },
    bookInfo: {
      plan: 'プラン',
      dateTime: '日時',
      validityPeriod: '有効期限',
      ticket: 'チケット',
      option: 'オプション',
      discount: '割引',
      total: '合計（税込）'
    },
    coupon: {
      title: '割引',
      caption: 'クーポンコードを入力',
      apply: '適用'
    },
    bookingDetailVoucher: {
      pdf: '印刷用PDF',
      html: 'バウチャーを表示'
    },
    collapsibleCard: {
      stockStatus: {
        available: '販売中',
        limited: '残りわずか',
        soldOut: '売り切れ'
      }
    },
    unitCard: {
      minCapacityWarning:
        '最少購入数は{{quantity}}点です。数量をご確認ください。',
      maxCapacityReached: '購入上限に達しました',
      optionQuantityLimitReached:
        '現在の選択内容では、このオプションを追加できません'
    }
  },
  bookingDetail: {
    title: '予約情報',
    meetingPoint: '入場場所のご案内',
    beforeTrip: 'ご利用前の確認事項',
    reservationInfo: '予約情報',
    redemption: 'Eチケットを利用',
    digitalTicketWaiting: '*注文確認後、電子チケットがここに表示されます',
    inclusion: '含まれるもの',
    restrictions: '参加制限',
    requirements: '参加前・参加時必要事項',
    attireItems: '参加時必要な服装・持ち物',
    otherInfo: '備考・その他',
    cancelSuccess: '予約をキャンセルしました。',
    sendToEmailSuccess: 'メール送信成功、メールをご確認ください',
    sendToEmailError: 'メールの送信に失敗しました。後ほど再度お試しください'
  },
  bookResult: {
    pendingTitle: '決済を確認しています',
    pendingMessage:
      'ご注文はまだ完了していません。処理が終わるまでこのままお待ちください。',
    successMessage:
      'ご予約ありがとうございます。予約バウチャーはすぐに登録したメールアドレスに送信されます、受信ボックスをご確認ください。',
    failedMessage: '支払いに失敗しました。再度予約してください。',
    timeoutMessage:
      'タイムアウトしました。しばらく経ってから、ブラウザをリロードするか、通知メールまたは以下の予約情報画面から、予約の有無をご確認ください。',
    backToProduct: '商品に戻る'
  },
  booking: {
    title: '予約情報',
    bookingNumber: '予約番号',
    viewDetail: '予約情報を見る',
    toBooking: '予約へ',
    bookingRange: {
      oneMonth: '1ヶ月以内の予約',
      threeMonths: '3ヶ月以内の予約',
      sixMonths: '半年間以内の予約'
    },
    plan: 'プラン',
    participationTime: '参加日時',
    validityPeriod: '有効期限',
    count: '数量',
    option: 'オプション',
    paidAmount: 'お支払い金額',
    customerName: '予約者名',
    refundAmount: '返金額',
    orderCompletionTime: '購入日時',
    adultTicket: '大人',
    childTicket: '小人',
    status: {
      BOOKING_STATUS_CONFIRMED: '予約完了',
      BOOKING_STATUS_PENDING: '予約中',
      BOOKING_STATUS_CANCEL_PENDING: 'キャンセル処理中、お待ちください',
      BOOKING_STATUS_CANCELED: 'キャンセル済み',
      BOOKING_STATUS_USED: '使用済み',
      BOOKING_STATUS_WITHDRAWN: '予約不成立',
      BOOKING_STATUS_APPLIED: '抽選申込受付完了',
      BOOKING_STATUS_APPLIED_DECLINED: '抽選は落ちました',
      BOOKING_STATUS_DECLINED: '抽選は落ちました'
    }
  }
};
